import * as yup from 'yup';
import { FEATURED_ACTION_TYPES } from '../../pass-templates-new/utils/featuredActionTypes';

export const HTTPS_URL_REGEX = /^https:\/\/\S+$/;

const featuredActionSlotSchema = yup.object({
  type: yup
    .string()
    .nullable()
    .oneOf([null, ...FEATURED_ACTION_TYPES], 'Select a valid action type')
    .test('type-required-with-url', 'Select an action type', function (type) {
      if (type) return true;
      return !this.parent?.url;
    }),
  url: yup
    .string()
    .nullable()
    .test(
      'url-required-with-type',
      'Add a URL for this featured action',
      function (url) {
        if (url) return true;
        return !this.parent?.type;
      }
    )
    .matches(HTTPS_URL_REGEX, {
      message: 'URL must start with https://',
      excludeEmptyString: true,
    }),
});

export const featuredActionsSchema = yup
  .object({
    one: featuredActionSlotSchema,
    two: featuredActionSlotSchema,
  })
  .test(
    'unique-featured-action-types',
    'Each featured action type can only be used once',
    function (value) {
      if (!value?.one?.type || !value?.two?.type) return true;
      if (value.one.type !== value.two.type) return true;
      return this.createError({
        path: `${this.path}.two.type`,
        message:
          'This action type is already used by the other featured action',
      });
    }
  );
